module.exports = __webpack_public_path__ + "assets/img/dwzq.899664e2.png";